<template>
    <temp-ranking-confirmation-list />
</template>

<script>
    import TempRankingConfirmationList from '../../components/dynamic/ranking/TempRankingConfirmationList';

    export default {
        components: {
            TempRankingConfirmationList
        }
    }
</script>

<style scoped>
</style>
